import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Rule_execution_alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.rule_execution_alerts_Id,
          sortable: true,
          cell: (row) => <span>{row.rule_execution_alerts_Id}</span>,
        },
        { name: "Table Rule Triggers Id", selector: (row, i) => row.table_rule_triggers_id, sortable: true, cell: (row) => <span>{row.table_rule_triggers_id}</span>, }, { name: "Alert Type", selector: (row, i) => row.alert_type, sortable: true, cell: (row) => <span>{row.alert_type}</span>, }, { name: "Alert Level", selector: (row, i) => row.alert_level, sortable: true, cell: (row) => <span>{row.alert_level}</span>, }, { name: "Alert Message ", selector: (row, i) => row.alert_message, sortable: true, cell: (row) => <span>{row.alert_message}</span>, }, { name: "Alert Data", selector: (row, i) => row.alert_data, sortable: true, cell: (row) => <span>{row.alert_data}</span>, }, { name: "Is Resolved", selector: (row, i) => row.is_resolved, sortable: true, cell: (row) => <span>{row.is_resolved}</span>, }, { name: "Resolved By ", selector: (row, i) => row.resolved_by, sortable: true, cell: (row) => <span>{row.resolved_by}</span>, }, { name: "Resolved At ", selector: (row, i) => row.resolved_at, sortable: true, cell: (row) => <span>{row.resolved_at}</span>, }, { name: "Resolution Notes", selector: (row, i) => row.resolution_notes, sortable: true, cell: (row) => <span>{row.resolution_notes}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Rule_execution_alertseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      rule_execution_alerts_Id: "",
      table_rule_triggers_id: '', alert_type: '', alert_level: '', alert_message: '', alert_data: '', is_resolved: '', resolved_by: '', resolved_at: '', resolution_notes: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'table_rule_triggers_id', inputType: 'Number', displayName: 'Table Rule Triggers Id', validationOptions: { isRequired: false } },
      { fieldName: 'alert_type', inputType: 'Text', displayName: 'Alert Type', validationOptions: { isRequired: false } },
      { fieldName: 'alert_level', inputType: 'Text', displayName: 'Alert Level', validationOptions: { isRequired: false } },
      { fieldName: 'alert_message', inputType: 'Text', displayName: 'Alert Message ', validationOptions: { isRequired: false } },
      { fieldName: 'alert_data', inputType: 'Text', displayName: 'Alert Data', validationOptions: { isRequired: false } },
      { fieldName: 'is_resolved', inputType: 'Text', displayName: 'Is Resolved', validationOptions: { isRequired: false } },
      { fieldName: 'resolved_by', inputType: 'Number', displayName: 'Resolved By ', validationOptions: { isRequired: false } },
      { fieldName: 'resolved_at', inputType: 'Date', displayName: 'Resolved At ', validationOptions: { isRequired: false } },
      { fieldName: 'resolution_notes', inputType: 'Text', displayName: 'Resolution Notes', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      table_rule_triggers_id: '', alert_type: '', alert_level: '', alert_message: '', alert_data: '', is_resolved: '', resolved_by: '', resolved_at: '', resolution_notes: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      table_rule_triggers_id: '', alert_type: '', alert_level: '', alert_message: '', alert_data: '', is_resolved: '', resolved_by: '', resolved_at: '', resolution_notes: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Rule_execution_alertseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      rule_execution_alerts_Id: row.rule_execution_alerts_Id,
      table_rule_triggers_id: row.table_rule_triggers_id, alert_type: row.alert_type, alert_level: row.alert_level, alert_message: row.alert_message, alert_data: row.alert_data, is_resolved: row.is_resolved, resolved_by: row.resolved_by, resolved_at: row.resolved_at, resolution_notes: row.resolution_notes,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Rule_execution_alertsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Rule_execution_alerts/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Rule_execution_alertssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('table_rule_triggers_id', this.state.table_rule_triggers_id);
    formData.append('alert_type', this.state.alert_type);
    formData.append('alert_level', this.state.alert_level);
    formData.append('alert_message', this.state.alert_message);
    formData.append('alert_data', this.state.alert_data);
    formData.append('is_resolved', this.state.is_resolved);
    formData.append('resolved_by', this.state.resolved_by);
    formData.append('resolved_at', this.state.resolved_at);
    formData.append('resolution_notes', this.state.resolution_notes);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Rule_execution_alerts/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_alertsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ table_rule_triggers_id: '', alert_type: '', alert_level: '', alert_message: '', alert_data: '', is_resolved: '', resolved_by: '', resolved_at: '', resolution_notes: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Rule_execution_alertsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("rule_execution_alerts_Id", this.state.rule_execution_alerts_Id);
    formData.append('table_rule_triggers_id', this.state.table_rule_triggers_id);
    formData.append('alert_type', this.state.alert_type);
    formData.append('alert_level', this.state.alert_level);
    formData.append('alert_message', this.state.alert_message);
    formData.append('alert_data', this.state.alert_data);
    formData.append('is_resolved', this.state.is_resolved);
    formData.append('resolved_by', this.state.resolved_by);
    formData.append('resolved_at', this.state.resolved_at);
    formData.append('resolution_notes', this.state.resolution_notes);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Rule_execution_alerts/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_alertsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Rule_execution_alertsfetchHandler();

    //***componentDidMount
  }

  handletable_rule_triggers_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ table_rule_triggers_id: fieldValue });
  }; handlealert_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ alert_type: fieldValue });
  }; handlealert_levelChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ alert_level: fieldValue });
  }; handlealert_messageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ alert_message: fieldValue });
  }; handlealert_dataChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ alert_data: fieldValue });
  }; handleis_resolvedChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ is_resolved: fieldValue });
  }; handleresolved_byChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resolved_by: fieldValue });
  }; handleresolved_atChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ resolved_at: fieldValue });
  }; handleresolution_notesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resolution_notes: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this rule_execution_alerts?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('rule_execution_alerts_Id', row.rule_execution_alerts_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Rule_execution_alerts/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_alertsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Rule Execution Alerts</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Rule_execution_alerts</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Table Rule Triggers Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handletable_rule_triggers_idChange} className="form-control" name="table_rule_triggers_id" value={this.state.table_rule_triggers_id} required="required" placeholder="Enter Table Rule Triggers Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_rule_triggers_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Alert Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlealert_typeChange} className="form-control" name="alert_type" value={this.state.alert_type} required="required" placeholder="Enter Alert Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Alert Level</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlealert_levelChange} className="form-control" name="alert_level" value={this.state.alert_level} required="required" placeholder="Enter Alert Level" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_level} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Alert Message </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlealert_messageChange} className="form-control" name="alert_message" value={this.state.alert_message} required="required" placeholder="Enter Alert Message " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_message} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Alert Data</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlealert_dataChange} className="form-control" name="alert_data" value={this.state.alert_data} required="required" placeholder="Enter Alert Data" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_data} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Resolved</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleis_resolvedChange} className="form-control" name="is_resolved" value={this.state.is_resolved} required="required" placeholder="Enter Is Resolved" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_resolved} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resolved By </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleresolved_byChange} className="form-control" name="resolved_by" value={this.state.resolved_by} required="required" placeholder="Enter Resolved By " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolved_by} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resolved At </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handleresolved_atChange} className="form-control" name="resolved_at" value={this.state.resolved_at} required="required" placeholder="Enter Resolved At " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolved_at} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resolution Notes</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresolution_notesChange} className="form-control" name="resolution_notes" value={this.state.resolution_notes} required="required" placeholder="Enter Resolution Notes" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolution_notes} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Rule_execution_alertssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Rule_execution_alerts</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Table Rule Triggers Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handletable_rule_triggers_idChange} className="form-control" name="table_rule_triggers_id" value={this.state.table_rule_triggers_id} required="required" placeholder="Enter Table Rule Triggers Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_rule_triggers_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Alert Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlealert_typeChange} className="form-control" name="alert_type" value={this.state.alert_type} required="required" placeholder="Enter Alert Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Alert Level</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlealert_levelChange} className="form-control" name="alert_level" value={this.state.alert_level} required="required" placeholder="Enter Alert Level" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_level} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Alert Message </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlealert_messageChange} className="form-control" name="alert_message" value={this.state.alert_message} required="required" placeholder="Enter Alert Message " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_message} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Alert Data</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlealert_dataChange} className="form-control" name="alert_data" value={this.state.alert_data} required="required" placeholder="Enter Alert Data" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.alert_data} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Resolved</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleis_resolvedChange} className="form-control" name="is_resolved" value={this.state.is_resolved} required="required" placeholder="Enter Is Resolved" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_resolved} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resolved By </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleresolved_byChange} className="form-control" name="resolved_by" value={this.state.resolved_by} required="required" placeholder="Enter Resolved By " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolved_by} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resolved At </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handleresolved_atChange} className="form-control" name="resolved_at" value={this.state.resolved_at} required="required" placeholder="Enter Resolved At " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolved_at} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resolution Notes</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresolution_notesChange} className="form-control" name="resolution_notes" value={this.state.resolution_notes} required="required" placeholder="Enter Resolution Notes" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resolution_notes} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Rule_execution_alertsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}